import React from "react";
import { Card, Skeleton } from "antd";
import { EditOutlined, FolderOutlined, VideoCameraOutlined } from "@ant-design/icons";
import moment from "moment";
import Highlighter from "react-highlight-words";
import CardMenuButton from "../CardMenuButton/CardMenuButton";
import "./CourseThumbnailCard.less";

const CourseThumbnailCard = ({ collection, hoverable = true, onEdit, index = 0, searchTerm = "" }) => {
    const getModuleCount = () =>
        collection?.moduleCount ?? collection?.modules?.length ?? 0;

    const getVideoCount = () => {
        if (typeof collection?.videoCount === "number") {
            return collection.videoCount;
        }
        if (!Array.isArray(collection?.modules)) {
            return 0;
        }
        return collection.modules.reduce(
            (total, module) => total + (module?.videos?.length || 0),
            0
        );
    };

    const getCreatedDateLabel = () => {
        if (!collection?.createdAt) {
            return "Created date unavailable";
        }
        const createdDate = new Date(collection.createdAt);
        if (Number.isNaN(createdDate.getTime())) {
            return "Created date unavailable";
        }

        return `Created on ${moment(createdDate).format("MM/DD/YYYY hh:mm A")}`;
    };

    return (
        <Card
            hoverable={hoverable}
            className="collection-card course-thumbnail-card"
            bordered
            style={{ animationDelay: `${60 * index}ms` }}
            cover={
                <>
                    <img
                        alt={collection?.name || "course"}
                        src={collection?.coverImage?.image}
                        className="course-thumbnail-card__cover-image"
                    />
                    <CardMenuButton
                        className="collection-card__menu-button"
                        items={[
                            {
                                label: "Edit",
                                key: "edit",
                                icon: <EditOutlined />
                            }
                        ]}
                        onMenuClick={(key) => {
                            if (key === "edit") {
                                onEdit?.(collection);
                            }
                        }}
                    />
                </>
            }>
            <Card.Meta
                title={
                    <Highlighter
                        searchWords={searchTerm ? [searchTerm] : []}
                        autoEscape
                        textToHighlight={collection?.name || ""}
                    />
                }
                description={
                    <>
                        <div className="my-content-created-date">
                            {getCreatedDateLabel()}
                        </div>
                        <div className="collection-details-bullets">
                            <span>
                                <FolderOutlined />
                                {getModuleCount()} Modules
                            </span>
                            <span>
                                <VideoCameraOutlined />
                                {getVideoCount()} Videos
                            </span>
                        </div>
                    </>
                }
            />
        </Card>
    );
};

export const CourseThumbnailCardSkeleton = ({ index = 0 }) => {
    return (
        <Card
            className="collection-card course-thumbnail-card"
            bordered
            style={{ animationDelay: `${60 * index}ms` }}
            cover={
                <div className="course-thumbnail-card__skeleton-cover">
                    <Skeleton.Image active className="course-thumbnail-card__skeleton-image" />
                </div>
            }>
            <Skeleton active title={{ width: "75%" }} paragraph={{ rows: 2 }} />
        </Card>
    );
};

export default CourseThumbnailCard;
